import "./new-reward.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormReward from "../form-reward/form-reward";
import { useNewReward } from "./new-reward.hook";

export function NewReward() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewReward();

  return (
    <div id="NewReward" className="reward">
      <HeaderContent
        title={<h1>New Reward</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormReward />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewReward;
